export default __webpack_public_path__ + "static/media/Styled-Components.976fdd27.png";